import { Component, computed, input, output } from '@angular/core';
import { ChipsFilterWithHeaderComponent } from '@vectronic/ui';
import { FilterItemWithLabel } from '@vectronic/util';

@Component({
  selector: 'table-datatable-filter-multi-select',
  templateUrl: './datatable-filter-multi-select.component.html',
  imports: [ChipsFilterWithHeaderComponent],
})
export class DatatableFilterSelectionComponent {
  title = input.required<string>();
  options = input<any>();
  value = input<any[] | undefined>();
  expanded = input.required<boolean>();
  disabled = input(false);

  valueChange = output<any[]>();
  toggled = output<void>();

  items = computed((): FilterItemWithLabel<any>[] => {
    const opts = this.options();
    if (Array.isArray(opts)) {
      return opts.map(({ item, label }) => ({ item, label }));
    }
    return [];
  });

  onSelectedItemsChange(items: any[] | undefined) {
    if (this.disabled()) return;

    this.valueChange.emit(items || []);
  }
}
